// extracted by mini-css-extract-plugin
module.exports = {"trustLogos":"trust_logos_trustLogos__MTVIC","trustLogo":"trust_logos_trustLogo__h3P0H"};